export type Category = {
  id: string;
  name: string;
  icon: string;
  color: string;
  desc: string;
};

export type HotItem = {
  rank: number;
  trend: number;
  title: string;
  heat: string;
  tag: string;
};

export type FeedItem = {
  id: string;
  title: string;
  summary: string;
  category: string;
  time: string;
  views: string;
  image: string;
  featured?: boolean;
};

export type TopicItem = {
  id: string;
  name: string;
  count: string;
  trend: "up" | "down" | "new";
};

export type SpecialItem = {
  id: string;
  title: string;
  desc: string;
  read: string;
  category: string;
  image: string;
};

export type Testimonial = {
  id: string;
  name: string;
  role: string;
  content: string;
  avatar: string;
  score: number;
};

export type FaqItem = {
  id: string;
  question: string;
  answer: string;
};

export const categories: Category[] = [
  { id: "all", name: "综合热榜", icon: "ri-fire-line", color: "primary", desc: "全网今日焦点" },
  { id: "star", name: "娱乐八卦", icon: "ri-star-smile-line", color: "accent", desc: "明星圈动态" },
  { id: "society", name: "社会热点", icon: "ri-earth-line", color: "primary", desc: "民生热议" },
  { id: "food", name: "生活趣闻", icon: "ri-cup-line", color: "secondary", desc: "人间烟火" },
  { id: "tech", name: "科技圈", icon: "ri-robot-2-line", color: "primary", desc: "数码与AI" },
  { id: "sport", name: "体娱前线", icon: "ri-trophy-line", color: "accent", desc: "赛场与综艺" },
];

export const hotList: HotItem[] = [
  { rank: 1, trend: 0, title: "顶流歌手新专辑上线首日霸榜，歌迷晒屏引爆热搜", heat: "1023.6万", tag: "爆" },
  { rank: 2, trend: 1, title: "国民综艺新一季官宣回归，嘉宾阵容引发全网大猜想", heat: "986.1万", tag: "热" },
  { rank: 3, trend: -1, title: "都市悬疑剧大结局口碑炸裂，细节彩蛋被逐帧解读", heat: "901.4万", tag: "热" },
  { rank: 4, trend: 2, title: "某当红艺人被曝低调捐款助学，粉丝回应早是常事", heat: "812.3万", tag: "赞" },
  { rank: 5, trend: 3, title: "00后整顿职场话题再上热榜，网友热议职场新生态", heat: "762.8万", tag: "热" },
  { rank: 6, trend: -2, title: "甜宠剧同款约会地成打卡新宠，小城文旅意外出圈", heat: "687.5万", tag: "新" },
  { rank: 7, trend: 1, title: "电竞战队世界赛逆转夺冠，粉丝狂欢全场沸腾", heat: "598.2万", tag: "热" },
  { rank: 8, trend: -3, title: "国货彩妆联名盲盒开售即空，二手价被炒至三倍", heat: "503.9万", tag: "新" },
  { rank: 9, trend: 4, title: "治愈系纪录片讲述市井烟火，弹幕直呼破防泪目", heat: "418.6万", tag: "暖" },
  { rank: 10, trend: 0, title: "AI换脸新规落地引热议，普通用户隐私边界被重新审视", heat: "351.2万", tag: "议" },
];

export const feedItems: FeedItem[] = [
  {
    id: "f1",
    title: "顶流歌手新专辑上线首日霸榜，多首新曲登热搜",
    summary: "专辑上线不到24小时便横扫各大音乐榜单，主打歌的旋律与歌词引发全网二创热潮，歌迷直呼'今年神专预定'。",
    category: "star",
    time: "2小时前",
    views: "112万",
    featured: true,
    image: "https://readdy.ai/api/search-image?query=warm%20golden%20studio%20music%20album%20cover%20with%20abstract%20singer%20silhouette%20in%20spotlight%2C%20coral%20and%20amber%20tones%2C%20premium%20editorial%20photography&width=900&height=620&seq=feed-f1&orientation=landscape",
  },
  {
    id: "f2",
    title: "国民综艺官宣回归，嘉宾阵容成全网最大悬念",
    summary: "时隔两年的国民综艺宣布新一季启动，官方仅发布一帧剪影预告，评论区已涌入数十万条阵容猜测。",
    category: "sport",
    time: "3小时前",
    views: "98万",
    image: "https://readdy.ai/api/search-image?query=vibrant%20variety%20show%20stage%20with%20confetti%20and%20spotlights%2C%20warm%20coral%20and%20cream%20palette%2C%20energetic%20editorial%20photography&width=900&height=620&seq=feed-f2&orientation=landscape",
  },
  {
    id: "f3",
    title: "悬疑剧大结局封神，细节彩蛋被网友逐帧解读",
    summary: "多线叙事终于收束，编剧埋下的伏笔几乎全部回收。剧粉自发整理时间线图谱，热度持续攀升。",
    category: "star",
    time: "5小时前",
    views: "87万",
    image: "https://readdy.ai/api/search-image?query=moody%20mystery%20thriller%20scene%20with%20fog%20and%20dim%20amber%20lights%2C%20noir%20cinematic%20still%2C%20warm%20tones%20editorial&width=900&height=620&seq=feed-f3&orientation=landscape",
  },
  {
    id: "f4",
    title: "当红艺人被曝常年低调助学，网友：这才是真正的星光",
    summary: "有网友扒出其多年匿名捐建乡村图书室，消息传开后其工作室仅回应一句'无需多言'，圈粉无数。",
    category: "society",
    time: "6小时前",
    views: "76万",
    image: "https://readdy.ai/api/search-image?query=heartwarming%20village%20library%20with%20warm%20sunlight%20and%20bookshelves%2C%20soft%20coral%20and%20cream%2C%20uplifting%20editorial%20photo&width=900&height=620&seq=feed-f4&orientation=landscape",
  },
  {
    id: "f5",
    title: "00后'整顿职场'再上热榜，新世代工作观引共鸣",
    summary: "从拒绝无效加班到讲究工作生活平衡，年轻人对职场的态度变化持续引发讨论，也推动企业思考管理升级。",
    category: "society",
    time: "8小时前",
    views: "65万",
    image: "https://readdy.ai/api/search-image?query=modern%20young%20professionals%20collaborating%20in%20bright%20office%20with%20plants%2C%20warm%20natural%20light%2C%20editorial%20photography%20coral%20accents&width=900&height=620&seq=feed-f5&orientation=landscape",
  },
  {
    id: "f6",
    title: "甜宠剧同款取景地走红，宝藏小城文旅意外出圈",
    summary: "剧中唯美场景带火一座安静小城，当地顺势推出'打卡路线'，短期游客量明显增长，网友笑称'被一部剧安利'。",
    category: "food",
    time: "9小时前",
    views: "54万",
    image: "https://readdy.ai/api/search-image?query=charming%20ancient%20small%20town%20with%20warm%20evening%20lanterns%20and%20canal%2C%20cozy%20golden%20tones%2C%20editorial%20travel%20photography&width=900&height=620&seq=feed-f6&orientation=landscape",
  },
  {
    id: "f7",
    title: "AI换脸新规落地：狂欢之后，隐私边界值得每个人关注",
    summary: "随着生成式AI普及，视频换脸的门槛越来越低。新规明确使用边界，普通用户也需提高警惕与媒介素养。",
    category: "tech",
    time: "11小时前",
    views: "43万",
    image: "https://readdy.ai/api/search-image?query=abstract%20digital%20face%20mesh%20in%20warm%20coral%20and%20amber%20hologram%20style%2C%20tech%20editorial%20illustration%20background&width=900&height=620&seq=feed-f7&orientation=landscape",
  },
  {
    id: "f8",
    title: "治愈系纪录片记录市井烟火，网友弹幕刷屏破防",
    summary: "镜头对准深夜街头的平凡人，没有刻意煽情却让无数观众落泪。'生活不易，但人间值得'成为刷屏注脚。",
    category: "food",
    time: "13小时前",
    views: "38万",
    image: "https://readdy.ai/api/search-image?query=night%20street%20food%20stall%20steam%20under%20warm%20lamp%20light%2C%20candid%20documentary%20style%2C%20golden%20amber%20tones%20editorial&width=900&height=620&seq=feed-f8&orientation=landscape",
  },
  {
    id: "f9",
    title: "国货彩妆联名盲盒开售即空，收藏热情高涨",
    summary: "设计与情怀兼具的联名盲盒上线数小时售罄，二手市场溢价明显。理性种草还是冲动消费，网友各执一词。",
    category: "tech",
    time: "16小时前",
    views: "29万",
    image: "https://readdy.ai/api/search-image?query=cosmetic%20blind%20box%20products%20on%20warm%20coral%20backdrop%2C%20cute%20packaging%2C%20commercial%20editorial%20product%20photography&width=900&height=620&seq=feed-f9&orientation=landscape",
  },
  {
    id: "f10",
    title: "电竞战队世界赛逆转夺冠，全场粉丝为之沸腾",
    summary: "决胜局完成惊天翻盘，队伍时隔多年再度捧杯。赛后热搜与弹幕齐飞，选手激动落泪的画面感动无数观众。",
    category: "sport",
    time: "19小时前",
    views: "88万",
    featured: true,
    image: "https://readdy.ai/api/search-image?query=esports%20arena%20stage%20with%20golden%20trophy%20confetti%20and%20spotlights%2C%20dramatic%20warm%20lighting%2C%20editorial%20photography&width=900&height=620&seq=feed-f10&orientation=landscape",
  },
];

export const topicList: TopicItem[] = [
  { id: "t1", name: "#新专辑上线首日霸榜", count: "6.2亿", trend: "up" },
  { id: "t2", name: "#国民综艺回归", count: "4.8亿", trend: "up" },
  { id: "t3", name: "#都市悬疑剧大结局", count: "4.1亿", trend: "new" },
  { id: "t4", name: "#00后整顿职场", count: "3.5亿", trend: "up" },
  { id: "t5", name: "#同款取景地打卡", count: "2.9亿", trend: "down" },
  { id: "t6", name: "#治愈系市井烟火", count: "2.2亿", trend: "up" },
];

export const specialList: SpecialItem[] = [
  {
    id: "s1",
    title: "2026上半年华语乐坛速览：谁能持续霸榜",
    desc: "从专辑销量到现场巡演，从新人爆红到老将回归，我们用一组榜单拆解今年上半年的华语乐坛格局与趋势。",
    read: "12分钟",
    category: "行业观察",
    image: "https://readdy.ai/api/search-image?query=concert%20crowd%20with%20phone%20lights%20under%20warm%20amber%20spotlights%2C%20music%20festival%20atmosphere%2C%20editorial%20photography%20coral%20tones&width=1200&height=760&seq=special-s1&orientation=landscape",
  },
  {
    id: "s2",
    title: "被热搜'定义'的一天：我们离真相有多远",
    desc: "当一件事被反复推上热搜，事实、情绪与流量如何交织？本篇复盘近期典型事件，聊聊舆论场里的冷静之道。",
    read: "15分钟",
    category: "深度思考",
    image: "https://readdy.ai/api/search-image?query=abstract%20concept%20of%20news%20and%20truth%20with%20magnifying%20glass%20and%20newspaper%20collage%2C%20warm%20golden%20and%20cream%2C%20editorial%20design&width=1200&height=760&seq=special-s2&orientation=landscape",
  },
  {
    id: "s3",
    title: "城市小店的烟火经济学：一部剧如何带火一座城",
    desc: "从取景地走红看文旅新玩法，我们走进这几座因影视剧出圈的宝藏小城，记录热闹背后的真实生意与温度。",
    read: "10分钟",
    category: "生活方式",
    image: "https://readdy.ai/api/search-image?query=cozy%20boutique%20cafe%20and%20shop%20street%20in%20warm%20morning%20light%2C%20small%20business%20storytelling%2C%20editorial%20photography%20amber%20tones&width=1200&height=760&seq=special-s3&orientation=landscape",
  },
];

export const testimonials: Testimonial[] = [
  {
    id: "m1",
    name: "晚风听歌",
    role: "娱乐资讯爱好者",
    content: "每天午休刷一眼吃瓜51的热榜，今天圈内又有什么新鲜事基本就门清了，更新快、选题也准。",
    avatar: "晚",
    score: 5,
  },
  {
    id: "m2",
    name: "小鹿乱撞",
    role: "吃瓜十级学者",
    content: "最惊喜的是专题板块，把热搜背后的来龙去脉讲得很清楚，不是只抛个标题就完事，值得慢慢看。",
    avatar: "鹿",
    score: 5,
  },
  {
    id: "m3",
    name: "阿哲同学",
    role: "社会新闻关注者",
    content: "从娱乐到社会热点都覆盖到了，时效性强。晚上睡前总习惯点开'今日热榜'看一遍，一天下来心里有数。",
    avatar: "哲",
    score: 4,
  },
];

export const faqList: FaqItem[] = [
  {
    id: "q1",
    question: "吃瓜51的内容多久更新一次？",
    answer: "吃瓜51的今日热榜与最新爆料基本做到全天滚动更新，工作日重点时段每半小时刷新一次热榜，突发热门事件则会第一时间跟进推送。",
  },
  {
    id: "q2",
    question: "吃瓜51的爆料与资讯从哪里来？",
    answer: "我们聚合公开的网络热点、权威媒体报道与多方信源进行整合梳理，力求把来龙去脉呈现清楚。涉及存疑信息会明确标注，引导读者理性看待。",
  },
  {
    id: "q3",
    question: "我发现了新鲜事或线索，该如何投稿爆料？",
    answer: "欢迎通过页面底部的'爆料投稿'表单分享线索，或发送到官方邮箱。投稿经核实后会优先收录进对应栏目，并注明信息整理来源。",
  },
  {
    id: "q4",
    question: "吃瓜51会搬运或编造不实内容吗？",
    answer: "不会。我们坚持基于可查证的信源做信息聚合与解读，反对为流量编造谣言。对反转与辟谣事件也会及时更新，做负责任的吃瓜平台。",
  },
  {
    id: "q5",
    question: "如何第一时间收到今日新瓜的推送？",
    answer: "在页面底部的'新瓜速递订阅'中输入邮箱即可订阅，我们会把每日热榜与精选话题整理成一份简报，定期发送到你的邮箱。",
  },
];

export const tickerItems: string[] = [
  "今日热榜已更新 · 顶流歌手新专辑霸榜",
  "国民综艺官宣回归，阵容悬念拉满",
  "治愈系市井纪录片看哭网友",
  "AI换脸新规落地引热议",
  "宝藏小城因甜宠剧出圈",
];